import { useState, useEffect, useCallback } from "react";

/**
 * Checkbox selection for medical partner admin list (per-page toggles, cleared when tab changes).
 */
export function useMedicalPartnerListSelection(activeTab) {
  const [selectedPartnerIds, setSelectedPartnerIds] = useState([]);

  const togglePartnerRowSelected = useCallback((id) => {
    setSelectedPartnerIds((prev) => {
      const s = new Set(prev.map(String));
      const sid = String(id);
      if (s.has(sid)) s.delete(sid);
      else s.add(sid);
      return Array.from(s);
    });
  }, []);

  const toggleSelectAllOnPage = useCallback((pageIds) => {
    setSelectedPartnerIds((prev) => {
      const s = new Set(prev.map(String));
      const ids = (pageIds || []).map(String);
      const allSelected = ids.length > 0 && ids.every((i) => s.has(i));
      if (allSelected) ids.forEach((i) => s.delete(i));
      else ids.forEach((i) => s.add(i));
      return Array.from(s);
    });
  }, []);

  const clearPartnerSelection = useCallback(() => setSelectedPartnerIds([]), []);

  useEffect(() => {
    setSelectedPartnerIds([]);
  }, [activeTab]);

  return {
    selectedPartnerIds,
    togglePartnerRowSelected,
    toggleSelectAllOnPage,
    clearPartnerSelection,
  };
}
